import { MouseEvent, useState } from 'react';

import { copyToClipboard } from 'app/utility/helpers';

export default function useCopyToClipboardButton() {
  const [isOpen, setIsOpen] = useState(false);

  function showNotification() {
    setIsOpen(true);
    setTimeout(() => {
      setIsOpen(false);
    }, 2000);
  }

  const onCopyToClipboardButtonClick = (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e.preventDefault();
    const self = e.currentTarget as HTMLButtonElement | HTMLAnchorElement;

    const href = (self.tagName.toLowerCase() === 'a' && (self as HTMLAnchorElement).href)
      ? (self as HTMLAnchorElement).href
      : self.dataset.href || window.location.href;
    if (!href) return;

    copyToClipboard(href);
    showNotification();
  };

  return {
    isOpen,
    setIsOpen,
    onCopyToClipboardButtonClick,
  };
}
